import { action, computed, extendObservable } from 'mobx';
import FetchService from './FetchService';
import moment from 'moment';
import { head } from 'lodash';

class ContractService {
  fetch = new FetchService();

  constructor() {
    extendObservable(this, {
      contract: null,
      usageStats: null,
      lastBill: null,
      availableSkus: computed(() => {
        if (!this.contract) {
          return [];
        }
        return this.contract.products.map((p) => p.hs_sku);
      }),
      productUsageStats: computed(() => {
        if (!this.contract || !this.contract.products) {
          return [];
        }
        return this.contract.products.map((product) => {
          let amount = 1;
          if (product.hs_sku === 'placement-test') {
            amount = this.usageStats?.placementCount || 0;
          }
          if (product.hs_sku === 'extra-license') {
            amount = this.usageStats?.activeStudents || 0;
          }

          return {
            ...product,
            amount,
            total: amount ? (amount - (product.freeAmount || 0)) * product.finalUnitPrice : 0,
          };
        });
      }),
      licensePrice: computed(() => {
        if (!this.contract || !this.contract.products) {
          return 0;
        }

        const extraLicenseProduct = this.contract.products.find((p) => p.hs_sku === 'extra-license');
        if (!extraLicenseProduct) {
          return 0;
        }

        return extraLicenseProduct.finalUnitPrice;
      }),
    });
  }

  init = action(() => {
    this.fetch
      .fetch({
        method: 'get',
        url: '/profile/contract',
      })
      .then(() => {
        if (this.fetch.data) {
          this.contract = this.fetch.data;

          const startCurrentBill = moment.utc(this.contract.startsAt).month(moment.utc().month());
          const endCurrentBill = startCurrentBill.clone().add(1, 'month').subtract(1, 'day');

          this.fetch
            .fetch({
              method: 'get',
              url: `/reports/date-range/usage-stats?from=${startCurrentBill.format(
                'YYYY-MM-DD'
              )}&to=${endCurrentBill.format('YYYY-MM-DD')}`,
            })
            .then(() => {
              if (this.fetch.data) {
                this.usageStats = head(this.fetch.data);
              }
              if (this.fetch.error) {
                this.usageStats = null;
              }
            });
        }
        if (this.fetch.error) {
          this.contract = null;
        }
      });
  });
}

const contractService = new ContractService();
export default contractService;
